export const TYPE_LOADING = 'resource/loading' as const
export const TYPE_SUCCESS = 'resource/success' as const
export const TYPE_FAILURE = 'resource/failure' as const

export type Loading = {
    type: typeof TYPE_LOADING
}
export type Success<T> = {
    type: typeof TYPE_SUCCESS,
    value: T
}
export type Failure = {
    type: typeof TYPE_FAILURE,
    error: unknown
}
export type ResourceType<T> = Loading | Success<T> | Failure

export class Resource<T> {
    readonly data: ResourceType<T>

    constructor(data: ResourceType<T>) {
        this.data = data

        Object.freeze(this)
    }

    static loading<T>(): Resource<T> {
        return new Resource({ type: TYPE_LOADING })
    }

    static failure<T>(e: unknown): Resource<T> {
        return new Resource({ type: TYPE_FAILURE, error: e })
    }

    static of<T>(value: T): Resource<T> {
        return new Resource({ type: TYPE_SUCCESS, value: value })
    }

    transform<U>(f: (value: T) => U): Resource<U> {
        switch(this.data.type) {
            case TYPE_SUCCESS: {
                const transformed = f(this.data.value)
                return Resource.of(transformed)
            }
            case TYPE_FAILURE: {
                return Resource.failure(this.data.error)
            }
            case TYPE_LOADING: {
                return Resource.loading()
            }
        }
    }

    get isLoading(): boolean {
        return this.data.type === TYPE_LOADING
    }

    get valueOrNull(): T | null {
        if (this.data.type === TYPE_SUCCESS) {
            return this.data.value
        }
        return null
    }
}
